module.exports = __webpack_public_path__ + "static/theme-editor-show-thumbnails-of-top-categories-8cb0e8c1fadd25e61f40798b91dc8b96.png";